import {
    LimitedAdvancedSettings,
    AdvancedSettingsPanel,
} from 'apps/studio/components/settings/fields/Base/advanced'

export const AdvancedPanel = AdvancedSettingsPanel(LimitedAdvancedSettings)
